import { render, staticRenderFns } from "./CustomerTodayComponent.vue?vue&type=template&id=1742c394&"
import script from "./CustomerTodayComponent.vue?vue&type=script&lang=js&"
export * from "./CustomerTodayComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports